import {Text, InlineLink} from '@primer/react-brand-next'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, INLINES, MARKS, type Document} from '@contentful/rich-text-types'
import {documentToPlainTextString, getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import styles from '../../FlexSuite.module.css'

export const getDescription = (description: Document) => {
  return documentToReactComponents(description, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Text>{children}</Text>,
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <InlineLink
            href={node.data.uri}
            {...getAnalyticsEvent({
              action: documentToPlainTextString(node, ' '),
              tag: 'hyperlink',
              location: 'Flex Suite Hero Description',
            })}
          >
            {children}
          </InlineLink>
        )
      },
    },
  })
}

export const getHeading = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderMark: {
      [MARKS.BOLD]: text => <span className={styles.heroHeading}>{text}</span>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
  })
}
